"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWatcher = void 0;
var rxjs_1 = require("rxjs");
var utils_1 = require("../utils/utils");
var UserAgent_1 = require("./Functions/UserAgent");
/** The subject that will emit events when tabbing state changes */
var subject = new rxjs_1.Subject();
var isTabbing = false;
var initialized = false;
var checkFocusable = function (ele) {
    var eleArray = ["a", "button", "input", "select", "textarea", "label"];
    var eleTag = ele.nodeName.toLowerCase();
    if (eleArray.indexOf(eleTag) > -1) {
        return true;
    }
    else {
        if (ele.getAttribute("tabindex") !== null && ele.getAttribute("tabindex") !== "-1") {
            return true;
        }
        else {
            return false;
        }
    }
};
var maybeStartTabbing = function (event) {
    var key = event.which || event.keyCode || 0;
    var eleFocusable = checkFocusable(event.target);
    if ((!isTabbing && key === 9) || key === 13 || key === 32 || key === 37 || key === 38 || key === 39 || key === 40) {
        if (initialized && eleFocusable) {
            document.documentElement.classList.add("is-tabbing");
            document.documentElement.classList.remove("is-mouse");
        }
        isTabbing = true;
        subject.next(isTabbing);
    }
};
var mouseClick = function () {
    var eleFocusable = checkFocusable(document.activeElement);
    if (eleFocusable) {
        document.documentElement.classList.add("is-mouse");
        document.documentElement.classList.remove("is-tabbing");
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var stopTabbing = function () {
    if (isTabbing) {
        if (initialized) {
            document.documentElement.classList.remove("is-mouse");
            document.documentElement.classList.remove("is-tabbing");
        }
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var addDeviceClass = function () {
    if (UserAgent_1.isAndroid()) {
        document.documentElement.classList.add("isAndroid");
    }
    if (UserAgent_1.isIos()) {
        document.documentElement.classList.add("isIOS");
    }
    if (UserAgent_1.isIE()) {
        document.documentElement.classList.add("isIE");
    }
    if (UserAgent_1.isMobileDevice()) {
        document.documentElement.classList.add("isMobile");
    }
    if (UserAgent_1.isKindle()) {
        document.documentElement.classList.add("isKindle");
    }
    if (UserAgent_1.isMac()) {
        document.documentElement.classList.add("isMac");
    }
    if (UserAgent_1.isPCDevice()) {
        document.documentElement.classList.add("isPC");
    }
    if (UserAgent_1.isChrome()) {
        document.documentElement.classList.add("isChrome");
    }
    if (UserAgent_1.isEdge()) {
        document.documentElement.classList.add("isEdge");
    }
    if (UserAgent_1.isSafari()) {
        document.documentElement.classList.add("isSafari");
    }
    if (UserAgent_1.isFirefox()) {
        document.documentElement.classList.add("isFirefox");
    }
    if (UserAgent_1.isTouch()) {
        document.documentElement.classList.add("isTouch");
    }
    addOrientationClass();
};
var addOrientationClass = function () {
    if (window.innerWidth < window.innerHeight) {
        document.documentElement.classList.add("isPortrait");
        document.documentElement.classList.remove("isLandscape");
    }
    if (window.innerWidth > window.innerHeight) {
        document.documentElement.classList.remove("isPortrait");
        document.documentElement.classList.add("isLandscape");
    }
};
utils_1.ssrSafe(function () {
    addEventListener("keyup", maybeStartTabbing);
    addEventListener("click", mouseClick);
    addEventListener("touchstart", stopTabbing);
    addEventListener("resize", addOrientationClass);
    if (document.readyState === "complete") {
        addDeviceClass();
    }
    else {
        addEventListener("DOMContentLoaded", addDeviceClass);
    }
}, [typeof addEventListener === "function"]);
var observable = subject.asObservable();
/**
 * Subscribe to this to see whenever the user starts or stops tabbing.
 */
exports.TabWatcher = {
    /** Initialize the default action (adding `is-tabbing` class to body). */
    initialize: function () {
        initialized = true;
    },
    /** Whether we are currently using tab to navigate. */
    get isTabbing() {
        return isTabbing;
    },
    /** Subscribe to this observable. */
    subscribe: observable.subscribe.bind(observable),
    /** Pipe this observable with operators. */
    pipe: observable.pipe.bind(observable),
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/TabWatcher.js
// module id = 1590
// module chunks = 8